{
  "name": "cem-web-app",
  "version": "0.1.60",
  "license": "MIT",
  "angular-cli": {},
  "scripts": {
    "ng": "ng",
    "bs:host": "browser-sync start --ws --proxy 'plex' --port 4200",
    "bs:local": "browser-sync start --server 'dist' --port 4200",
    "bump": "bump package.json -y",
    "ci:bump": "npm run bump && node build-date.js",
    "ci:git": "npm run git:config:1 && npm run git:config:2 && npm run git",
    "serve": "node --max_old_space_size=4096 node_modules/@angular/cli/bin/ng serve --port 4300",
    "start": "npm install && echo 'Starting build and serve' && ng serve --hmr",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "build:prod-sourcemap": "ng build --configuration production -sm",
    "build:prod-no-aot": "ng build --configuration production --no-aot --no-build-optimizer",
    "git": "npm run git:add && npm run git:commit && npm run git:push",
    "git:add": "git add .",
    "git:commit": "git commit -m 'bump & datestamp'",
    "git:push": "git push",
    "serve-prod": "http-server ./dist -p 1001",
    "test": "ng test",
    "test:headless": "ng test --watch=false",
    "browsersync": "browser-sync start --ws --proxy 'localhost:4200' --port 4000",
    "coverage": "http-server -c-1 -o -p 9875 ./coverage",
    "e2e": "ng e2e",
    "build-dev": "ng build --configuration=development --aot",
    "build-tst": "ng build --configuration=test --aot",
    "build-prd": "ng build --configuration=production --aot"
  },
  "private": true,
  "dependencies": {
    "@angry-yard/coleslaw": "^0.1.1",
    "@angular/animations": "^22.1.3",
    "@angular/cdk": "^21.1.4",
    "@angular/common": "^22.1.3",
    "@angular/compiler": "^22.1.3",
    "@angular/core": "^22.1.3",
    "@angular/forms": "^22.1.3",
    "@angular/material": "^21.1.4",
    "@angular/platform-browser": "^22.1.3",
    "@angular/platform-browser-dynamic": "^22.1.3",
    "@angular/router": "^22.1.3",
    "@azure/msal-angular": "^5.0.4",
    "@azure/msal-browser": "^5.2.0",
    "@fortawesome/free-solid-svg-icons": "^7.2.0",
    "@microsoft/applicationinsights-web": "^3.3.11",
    "@microsoft/signalr": "^10.0.0",
    "@progress/kendo-angular-buttons": "^24.1.0",
    "@progress/kendo-angular-charts": "24.1",
    "@progress/kendo-angular-common": "24.1",
    "@progress/kendo-angular-dateinputs": "24.1",
    "@progress/kendo-angular-dialog": "24.1",
    "@progress/kendo-angular-dropdowns": "24.1",
    "@progress/kendo-angular-excel-export": "24.1",
    "@progress/kendo-angular-grid": "24.1",
    "@progress/kendo-angular-icons": "24.1",
    "@progress/kendo-angular-indicators": "24.1",
    "@progress/kendo-angular-inputs": "24.1",
    "@progress/kendo-angular-intl": "24.1",
    "@progress/kendo-angular-l10n": "24.1",
    "@progress/kendo-angular-label": "24.1",
    "@progress/kendo-angular-layout": "24.1",
    "@progress/kendo-angular-menu": "24.1",
    "@progress/kendo-angular-popup": "24.1",
    "@progress/kendo-angular-tooltip": "24.1",
    "@progress/kendo-angular-utils": "24.1",
    "@progress/kendo-data-query": "^1.7.3",
    "@progress/kendo-date-math": "^1.5.15",
    "@progress/kendo-drawing": "^1.24.0",
    "@progress/kendo-licensing": "^1.11.2",
    "@progress/kendo-theme-bootstrap": "^13.0.1",
    "@progress/kendo-theme-default": "^13.0.1",
    "@types/moment-duration-format": "^2.2.3",
    "@types/selenium-webdriver": "^4.35.5",
    "@vitest/browser-playwright": "^4.1.0",
    "ag-grid-angular": "^35.1.0",
    "ag-grid-enterprise": "^35.1.0",
    "bootstrap": "^5.3.3",
    "dayjs": "^1.11.9",
    "dayjs-with-plugins": "^1.0.3",
    "fluentvalidation-ts": "^5.0.0",
    "hammerjs": "^2.0.8",
    "moment": "^2.30.1",
    "moment-duration-format": "^2.3.2",
    "ngx-drag-drop": "^21.0.0",
    "ngx-json-viewer": "^3.2.1",
    "perfect-scrollbar": "^1.5.6",
    "rxjs": "^7.8.2",
    "rxjs-compat": "^6.6.7",
    "sass": "^1.97.3",
    "screenfull": "^6.0.2",
    "ts-helpers": "^1.1.2",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.0"
  },
  "devDependencies": {
    "@angular/build": "^22.1.5",
    "@angular/cli": "^22.1.5",
    "@angular/compiler-cli": "^22.1.3",
    "@angular/language-service": "^22.1.3",
    "@angular/localize": "^22.1.3",
    "@angularclass/hmr": "^3.0.0",
    "@types/applicationinsights-js": "^1.0.9",
    "@types/node": "^25.2.3",
    "bump-cli": "^2.9.12",
    "html-webpack-plugin": "^5.6.6",
    "jsdom": "^29.0.0",
    "kendo-ui-license": "^1.0.1",
    "replace-in-file": "^8.4.0",
    "sass": "^1.97.3",
    "sass-loader": "^16.0.7",
    "ts-node": "^10.9.1",
    "typescript": "^6.0.3",
    "vitest": "^4.1.0"
  }
}